import React from 'react';
import { Card } from '@tribeplatform/react-ui-kit/Card';
import { GridList } from '@tribeplatform/react-ui-kit/Layout';
export const CollectionListLoading = ({ count = 16 }) => {
    return (React.createElement(React.Fragment, null, [...Array(count)].map((_e, i) => (React.createElement(GridList.Item, { key: i },
        React.createElement(Card, { className: "h-full" },
            React.createElement("div", { className: "animate-pulse flex-1 flex flex-col mb-2 p-6 pt-4 space-y-3 items-center text-center" },
                React.createElement("div", { className: "mb-3 w-24 h-24 rounded-full bg-skeleton" }),
                React.createElement("div", { className: "h-4 bg-skeleton rounded-full w-2/3" }),
                React.createElement("div", { className: "h-4 bg-skeleton rounded-full w-3/4" }))))))));
};
//# sourceMappingURL=CollectionListLoading.js.map